import {
  DocumentOrganizationKeys,
  FilterDocument,
  FilterDocumentDateCustomTypes,
  FilterDocumentDateFilterTypes,
  FilterOptionKeys,
  Timestamp,
} from '@griply/types';

export const getDateFilterEndDate = (
  filterDocument: FilterDocument | undefined | null,
): Timestamp | undefined => {
  if (!filterDocument) {
    return undefined;
  }

  const directDateFilter =
    filterDocument[DocumentOrganizationKeys.Filters]?.[FilterOptionKeys.Date] ??
    null;
  if (
    directDateFilter?.type === FilterDocumentDateFilterTypes.Custom &&
    directDateFilter.custom?.type === FilterDocumentDateCustomTypes.Before &&
    directDateFilter.custom.end
  ) {
    return directDateFilter.custom.end;
  }

  const orBranches = filterDocument[DocumentOrganizationKeys.Or] ?? [];
  for (const branch of orBranches) {
    const branchDateFilter = branch[FilterOptionKeys.Date];
    if (
      branchDateFilter?.type === FilterDocumentDateFilterTypes.Custom &&
      branchDateFilter.custom?.type === FilterDocumentDateCustomTypes.Before &&
      branchDateFilter.custom.end
    ) {
      return branchDateFilter.custom.end;
    }
  }

  return undefined;
};
